/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPresentation} from '@fortawesome/pro-duotone-svg-icons';

const InstituteFormsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPresentation} {...props} />
);

export default InstituteFormsIcon;
